var map = {
  "./snowflake.md": [
    "75558",
    "971"
  ],
  "./mysql.md": [
    "35048",
    "825"
  ],
  "./sql-server.md": [
    "65060",
    "285"
  ],
  "./postgresql.md": [
    "7146",
    "831"
  ],
  "./databricks.md": [
    "99202",
    "615"
  ],
  "./aws-rds.md": [
    "40797",
    "86"
  ],
  "./bigquery.md": [
    "37134",
    "411"
  ],
  "./presto.md": [
    "29487",
    "940"
  ],
  "./sqlite.md": [
    "78320",
    "513"
  ],
  "./starburst.md": [
    "64880",
    "641"
  ],
  "./redshift.md": [
    "86657",
    "58"
  ],
  "./druid.md": [
    "13854",
    "507"
  ],
  "./sparksql.md": [
    "72371",
    "952"
  ],
  "./mariadb.md": [
    "89690",
    "983"
  ],
  "./mongodb.md": [
    "8660",
    "69"
  ],
  "./oracle.md": [
    "91286",
    "739"
  ],
  "./vertica.md": [
    "90688",
    "89"
  ],
  "./clickhouse.md": [
    "85676",
    "445"
  ],
  "./athena.md": [
    "34339",
    "88"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 1 | 16);
  });
}

webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 72976;
module.exports = webpackAsyncContext;
